export const BITUM_MATERIALS = 'bitumnye-materialy';

export const RUSSIA = 'russia';

export default {
  RUSSIA,
  BITUM_MATERIALS,
};
